export const services = {
	title: "Services",
	servicesLine1: "Do you need some kind of special workflow to help move data from your models or drawings to downstream users? We specialize in helping you move data from source to destination without having to re-create, duplicate or otherwise duplicate your effort.",
	servicesLine2: "Let us help you maintain your data integrity and efficiency.",
};
